import { observer } from "mobx-react";

import IntroPoints from "../IntroPoints/IntroPoints";
import AnimationScene from "./IntroIllustrationGoogle/components/AnimationScene/AnimationScene";
import Button from "components/UI/Button/Button";

import { COUNT_COMPLETED_TASKS, COUNT_EXCHANGE_USAGE } from "utils/helpers";

import "./IntroGoogleSeo.scss";

const SEO_STEPS_BASE = [
  {
    title: "Естественный переход от поиска к сайту",
    description:
      "Тестировщики начинают с Google, находят ваш сайт в топ-результатах, ведут себя как реальные потенциальные клиенты",
  },
  {
    title: "Мощные поведенческие сигналы",
    description:
      "Повторные посещения, взаимодействие с формами, изучение контактов, микроконверсии, которые важны для NavBoost и моделей удовлетворенности в 2026 году",
  },
  {
    title: "Полезная обратная связь",
    description:
      "Каждая сессия сопровождается записями мыслей вслух, оценками доверия и предложениями по улучшению пользовательского опыта, чтобы сделать ваш сайт быстрее и интуитивно понятнее",
  },
  {
    title: "Mobile-First (70%+ сессий)",
    description:
      "Большинство действий выполняется на реальных смартфонах — это критично для INP, мобильной удобности и текущих приоритетов Google",
  },
  {
    title: "Безопасно и в рамках правил",
    description:
      "Соответствие GDPR, никаких black-hat практик — акцент на естественных паттернах вовлечённости и качественных сигналах",
  },
  {
    title: "Измеримый эффект",
    description:
      "Отслеживайте рост времени на сайте, снижение pogo-sticking, увеличение брендовых запросов и вовлечённости со временем",
  },
];

const SEO_STEP_MOBILE_ONLY = {
  title: "125 000+ реальных людей, БЕЗ ботов",
  description:
    "Квалифицированные тестировщики из целевых стран (US/UK/EU и т.д.) используют свои собственные устройства и реальные сессии Chrome",
};

const StatsBlock = () => (
  <div className="intro-google-seo__right">
    <div className="intro-google-seo__right-img-lt" />
    <div className="intro-google-seo__right-img-rt" />
    <div className="intro-google-seo__right-img-rb" />
    <div className="intro-google-seo__right-img-lb" />
    <div className="intro-google-seo__right-img-c" />
    <div className="intro-google-seo__right-info-tasks">
      <p>{COUNT_COMPLETED_TASKS.toLocaleString()}</p>
      <span>задач выполнено</span>
    </div>
    <div className="intro-google-seo__right-info-usage">
      <p>{COUNT_EXCHANGE_USAGE.toLocaleString()}</p>
      <span>используют Boostclick</span>
    </div>
  </div>
);

const IntroGoogleSeo = observer(({ title, comment, nextStep, isMobile }) => {
  const seoSteps = isMobile ? [SEO_STEP_MOBILE_ONLY, ...SEO_STEPS_BASE] : SEO_STEPS_BASE;

  function onClickNext() {
    if (nextStep?.current) {
      const headerHeight = 80;
      const yOffset =
        nextStep.current.getBoundingClientRect().top +
        window.scrollY -
        headerHeight;
      window.scrollTo({ top: yOffset, behavior: "smooth" });
    }
  }

  return (
    <div className="intro-google-seo">
      <div className="intro-google-seo__plate">
        {isMobile && <AnimationScene />}
        <div className="intro-google-seo__plate-header">
          <h1 className="intro-google-seo__plate-header-title">{title}</h1>
          <p className="intro-google-seo__plate-header-comment">{comment}</p>
          <Button
            className="intro-google-seo__button-free"
            title="Начать бесплатно"
            onClick={onClickNext}
          />
        </div>
        {!isMobile && <AnimationScene />}
        <div className="intro-google-seo__plate-bg" />
      </div>

      <div className="intro-google-seo__container">
        <div className="intro-google-seo__wrapper">
          {!isMobile && <h2>Почему выбирают BOOSTCLICK?</h2>}
          {isMobile && <StatsBlock />}
          <div className="intro-google-seo__wrapper-left">
            <IntroPoints stepLength={seoSteps} vertical={!isMobile} />
          </div>
        </div>

        {!isMobile && (
          <div className="intro-google-seo__wrapper">
            <StatsBlock />
            <div className="intro-google-seo__right-description">
              <h4>{SEO_STEP_MOBILE_ONLY.title}</h4>
              <p>{SEO_STEP_MOBILE_ONLY.description}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default IntroGoogleSeo;
